import React from "react";
import PropTypes from "prop-types";

import styles from "./style.css";

export function Checklist(props) {
  const { value = [] } = props;

  const selectedCount =
    (value && value.filter && value.filter((val) => val.selected).length) || 0;
  return (
    <React.Fragment>
      <div className={`${styles.checklist} ellipsis`}>
        {value &&
          value.filter &&
          value
            .filter((val) => val.selected)
            .map((val) => val.value)
            .join(", ")}
      </div>
      <div className={styles.checklistprogress}>{`${selectedCount}/${
        value?.length || 0
      }`}</div>
    </React.Fragment>
  );
}

Checklist.propTypes = {
  value: PropTypes.bool
};
